import React, { useEffect, useState } from 'react';
import { getActiveEvents } from '../../services/eventsService';
import '../game/game.css';

export default function ActiveEventBanner({ onEvents }) {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    let alive = true;
    getActiveEvents()
      .then((list) => {
        if (!alive) return;
        setEvents(list);
        onEvents?.(list);
      })
      .catch(() => { if (alive) setEvents([]); });
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (events.length === 0) return null;

  return (
    <div className="active-event-banner">
      {events.map((ev) => (
        <div key={ev.id} className="active-event-item">
          <i className="bi bi-stars" />
          <div className="active-event-text">
            <strong>{ev.name}</strong>
            {ev.description && <span>{ev.description}</span>}
          </div>
          {Number(ev.xpMultiplier) > 1 && (
            <span className="active-event-xp">XP x{ev.xpMultiplier}</span>
          )}
        </div>
      ))}
    </div>
  );
}
